<template>
  <form class="PlanRouteForm" @submit.prevent="submit">
    <h2 class="title is-6">{{ isEditMode ? 'Edycja trasy' : 'Trasa' }}</h2>

    <b-message v-if="formError" type="is-danger" size="is-small">
      {{ formError }}
    </b-message>

    <b-field label="Nazwa trasy" :type="fieldType('name')" :message="fieldMessage('name')">
      <b-input v-model="name" required :disabled="isSaving"/>
    </b-field>

    <b-field label="Użytkownik" :type="fieldType('user')" :message="fieldMessage('user')">
      <b-select v-model="user" expanded :disabled="isSaving || isUsersLoading">
        <option :value="null">Bez przypisania</option>
        <option v-for="user in users" :key="user.id" :value="userToIri(user)">
          {{ user.username || user.name || ('Uzytkownik #' + user.id) }}
        </option>
      </b-select>
    </b-field>

    <b-field label="Kolor" :type="fieldType('color')" :message="fieldMessage('color')">
      <div class="PlanRouteForm__colors">
        <button
            v-for="color in colors"
            :key="color.hex"
            type="button"
            class="PlanRouteForm__color"
            :class="{ 'is-selected': routeColor === color.hex }"
            :style="{ backgroundColor: color.hex }"
            :title="color.name"
            @click="routeColor = color.hex"
            :disabled="isSaving"
        >
          <span v-if="routeColor === color.hex" class="mdi">check</span>
        </button>
        <button
            type="button"
            class="button is-small"
            @click="routeColor = null"
            :disabled="isSaving"
        >
          Brak
        </button>
      </div>
    </b-field>

    <button
        type="submit"
        class="button is-success is-fullwidth"
        :class="{ 'is-loading': isSaving }"
        :disabled="isSaving"
    >
      <i class="mdi">{{ isEditMode ? 'save' : 'playlist_add_check' }}</i>
      <span>{{ isEditMode ? 'Zapisz zmiany' : 'Utwórz trasę' }}</span>
    </button>
  </form>
</template>

<script>
import moment from 'moment'
import {ROUTE_COLORS, DEFAULT_ROUTE_COLOR} from '@/configs/routeColors'

export default {
  name: 'PlanRouteForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      default: () => []
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    isUsersLoading: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    formError: {
      type: String,
      default: ''
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colors: ROUTE_COLORS.map(color => ({name: color.label, hex: color.value}))
    }
  },
  computed: {
    name: {
      get() {
        return this.value.name || this.defaultRouteName()
      },
      set(name) {
        this.$emit('input', {...this.value, name})
      }
    },
    user: {
      get() {
        return this.value.user || null
      },
      set(user) {
        this.$emit('input', {...this.value, user})
      }
    },
    routeColor: {
      get() {
        return this.value.color || DEFAULT_ROUTE_COLOR
      },
      set(color) {
        this.$emit('input', {...this.value, color})
      }
    }
  },
  methods: {
    defaultRouteName() {
      return `Trasa ${moment().format('DD.MM.YYYY')}`
    },
    userToIri(user) {
      return user['@id'] || `/api/users/${user.id}`
    },
    submit() {
      this.$emit('submit')
    },
    getError(field) {
      return this.errors.find(error => error.field === field)
    },
    fieldType(field) {
      return this.getError(field) ? 'is-danger' : null
    },
    fieldMessage(field) {
      const error = this.getError(field)
      return error ? error.message : null
    }
  }
}
</script>

<style lang="scss" scoped>
.PlanRouteForm {
  .title {
    margin-bottom: 10px;
  }

  &__colors {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
  }

  &__color {
    width: 28px;
    height: 28px;
    border: 2px solid #ddd;
    border-radius: 3px;
    cursor: pointer;

    &.is-selected {
      border-color: #222;
    }

    .mdi {
      color: #fff;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
    }
  }

  .button .mdi {
    margin-right: 5px;
  }
}
</style>